/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseCarouselFragment, CarouselFragment, FullCarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel';

/**
 * Get a single Carousel by ID (base - scalars only)
 */
export const getBaseCarouselById = gql`
  ${BaseCarouselFragment}

  query GetBaseCarouselById($id: String!, $locale: String!, $preview: Boolean) {
    carousel(id: $id, locale: $locale, preview: $preview) {
      ...BaseCarouselFragment
    }
  }
`;

/**
 * Get a single Carousel by ID (standard - 1 level deep)
 */
export const getCarouselById = gql`
  ${CarouselFragment}

  query GetCarouselById($id: String!, $locale: String!, $preview: Boolean) {
    carousel(id: $id, locale: $locale, preview: $preview) {
      ...CarouselFragment
    }
  }
`;

/**
 * Get a single Carousel by ID (full - 2 levels deep)
 */
export const getFullCarouselById = gql`
  ${FullCarouselFragment}

  query GetFullCarouselById($id: String!, $locale: String!, $preview: Boolean) {
    carousel(id: $id, locale: $locale, preview: $preview) {
      ...FullCarouselFragment
    }
  }
`;

/**
 * Get all Carousel entries with pagination (base - scalars only)
 */
export const getBaseCarousels = gql`
  ${BaseCarouselFragment}

  query GetBaseCarousels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CarouselOrder]
    $where: CarouselFilter
    $preview: Boolean
  ) {
    carouselCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseCarouselFragment
      }
    }
  }
`;

/**
 * Get all Carousel entries with pagination (standard - 1 level deep)
 */
export const getCarousels = gql`
  ${CarouselFragment}

  query GetCarousels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CarouselOrder]
    $where: CarouselFilter
    $preview: Boolean
  ) {
    carouselCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...CarouselFragment
      }
    }
  }
`;

/**
 * Get all Carousel entries with pagination (full - 2 levels deep)
 */
export const getFullCarousels = gql`
  ${FullCarouselFragment}

  query GetFullCarousels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CarouselOrder]
    $where: CarouselFilter
    $preview: Boolean
  ) {
    carouselCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullCarouselFragment
      }
    }
  }
`;
